import React from 'react';

function GetInTouch() {
    return (
        <section className="contact bg-light border-top border-bottom py-5 my-4" aria-label="Contact call to action">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 text-center">
                        <h2 className="h4 text-uppercase font-weight-bold text-danger mb-2">Have a Project for Me?</h2>
                        <h3 className="h2 font-weight-bold text-dark mb-3">GET IN TOUCH!</h3>
                        <p className="text-muted mb-4">Interested in collaborating or discussing web, mobile, or software engineering solutions?</p>
                        <a 
                            className="btn btn-primary text-white btn-lg shadow-sm px-4 py-2 font-weight-bold rounded-pill contact-btn-highlight" 
                            href="https://amanur.com#contact"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Contact Me Today &rarr;
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default GetInTouch;
